import { useAccountTypeStructures } from "@features/tickets/shared/hooks/useAccountTypeStructures";
import { ITEM_STRUCTURE_TYPE } from "./items.constants";

export function useItemStructures() {
  return useAccountTypeStructures(ITEM_STRUCTURE_TYPE);
}
